// Shared assistant-chat transport for the report widget flows. The edit-modal
// NL box (useAddWidget) and each grid add tile (PendingWidgetBuild) run the
// same agent with the same request body; this factory keeps that wiring in one
// place. (The full report build runs in the assistant panel, not through
// this.) Colocated with the consuming views.

import { AI_SERVICE_URL } from '@/config/constants';
import { DefaultChatTransport } from 'ai';

/**
 * Build the DefaultChatTransport the report chats use. Geo, model tier, and the
 * searchable-industry allowlist are read through refs so the once-memoized
 * transport always sends the latest values. Reports aren't page-contextual, so
 * pageContext is null; userIndustries mirrors normal chat so get_entity applies
 * the same industry facet (without it, hidden industries leak into resolution).
 *
 * Deliberately NO `clientTools` opt-in here: these chats (the add-widget tile
 * and the edit-modal NL box) can't execute create_report, so the model must
 * never see the tool in them. The full report build runs in the assistant
 * panel, which opts in via its own transport.
 */
export const createReportChatTransport = ({
    getAccessTokenSilently,
    geoRef,
    modelTierRef,
    industriesRef,
}) =>
    new DefaultChatTransport({
        api: `${AI_SERVICE_URL}/ai/assistant/`,
        headers: async () => {
            const token = await getAccessTokenSilently();
            return { Authorization: `Bearer ${token}` };
        },
        body: () => ({
            pageContext: null,
            geo: geoRef.current,
            userIndustries: industriesRef.current,
            modelTier: modelTierRef.current,
        }),
    });
